interface DashboardIconProps {
  color: string;
}

export const DashboardIcon = ({ color }: DashboardIconProps) => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.23438 0H2.375C1.06318 0 0 1.11914 0 2.5V8.4375C0 9.81836 1.06318 10.9375 2.375 10.9375H6.23438C7.54619 10.9375 8.60938 9.81836 8.60938 8.4375V2.5C8.60938 1.11914 7.54619 0 6.23438 0ZM6.82812 8.4375C6.82812 8.78281 6.56242 9.0625 6.23438 9.0625H2.375C2.04695 9.0625 1.78125 8.78281 1.78125 8.4375V2.5C1.78125 2.15469 2.04695 1.875 2.375 1.875H6.23438C6.56242 1.875 6.82812 2.15469 6.82812 2.5V8.4375Z"
        fill={color ?? '#4B5851'}
      />
      <path
        d="M6.23438 12.8125H2.375C1.06318 12.8125 0 13.9316 0 15.3125V17.5C0 18.8809 1.06318 20 2.375 20H6.23438C7.54619 20 8.60938 18.8809 8.60938 17.5V15.3125C8.60938 13.9316 7.54619 12.8125 6.23438 12.8125ZM6.82812 17.5C6.82812 17.8453 6.56242 18.125 6.23438 18.125H2.375C2.04695 18.125 1.78125 17.8453 1.78125 17.5V15.3125C1.78125 14.9672 2.04695 14.6875 2.375 14.6875H6.23438C6.56242 14.6875 6.82812 14.9672 6.82812 15.3125V17.5Z"
        fill={color ?? '#4B5851'}
      />
      <path
        d="M12.7656 20H16.625C17.9368 20 19 18.8809 19 17.5V11.5625C19 10.1816 17.9368 9.0625 16.625 9.0625H12.7656C11.4538 9.0625 10.3906 10.1816 10.3906 11.5625V17.5C10.3906 18.8809 11.4538 20 12.7656 20ZM12.1719 11.5625C12.1719 11.2172 12.4376 10.9375 12.7656 10.9375H16.625C16.953 10.9375 17.2188 11.2172 17.2188 11.5625V17.5C17.2188 17.8453 16.953 18.125 16.625 18.125H12.7656C12.4376 18.125 12.1719 17.8453 12.1719 17.5V11.5625Z"
        fill={color ?? '#4B5851'}
      />
      <path
        d="M12.7656 7.1875H16.625C17.9368 7.1875 19 6.06836 19 4.6875V2.5C19 1.11914 17.9368 0 16.625 0H12.7656C11.4538 0 10.3906 1.11914 10.3906 2.5V4.6875C10.3906 6.06836 11.4538 7.1875 12.7656 7.1875ZM12.1719 2.5C12.1719 2.15469 12.4376 1.875 12.7656 1.875H16.625C16.953 1.875 17.2188 2.15469 17.2188 2.5V4.6875C17.2188 5.03281 16.953 5.3125 16.625 5.3125H12.7656C12.4376 5.3125 12.1719 5.03281 12.1719 4.6875V2.5Z"
        fill={color ?? '#4B5851'}
      />
    </svg>
  );
};
